/**
 * Light background tint of any CSS colour (hex, rgb, token value) for icon tiles and chips.
 * Uses `color-mix` so it works for every colour format, not only 7-digit hex.
 * @param percent - Share of the colour in the mix; 10 matches the old `${hex}1a` tint.
 */
export function tintColor(color: string, percent = 10): string {
  return `color-mix(in srgb, ${color} ${percent}%, transparent)`;
}
